// React Island Registry — maps component names to lazy-loaded imports
// esbuild bundles these into app/assets/builds/react_bundle.js

import React from "react"
import { createRoot } from "react-dom/client"

// Import GetStream CSS (works with esbuild bundling)
import "stream-chat-react/dist/css/v2/index.css"

// Import dark theme overrides
import "./styles/getstream-dark.css"

// Expose React + ReactDOM for the Stimulus react_island_controller
window.__REACT__ = React
window.__REACT_CREATE_ROOT__ = createRoot

window.__REACT_COMPONENTS__ = {
  ChatWidget: () => import("./components/ChatWidget"),
  MessengerInbox: () => import("./components/MessengerInbox"),
  ActivityFeed: () => import("./components/ActivityFeed"),
  NotificationFeed: () => import("./components/NotificationFeed"),
  ForYouFeed: () => import("./components/ForYouFeed"),
  ReactionBar: () => import("./components/ReactionBar"),
  PollWidget: () => import("./components/PollWidget"),
}
